<template>
  <div id="my-own-events">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("contentManagement.areaMap.filter") }}</h5>
                <span>{{ $t("contentManagement.areaMap.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="searchTerm" :placeholder="$t('placeholder.search')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("myOwnEvents.title") }}</h5>
              <!-- <span v-if="getEvents != null" v-html="$t('totalContent', [getEvents.length])"></span> -->
              <template v-if="getEvents.length > 0">
                <span v-if="getEvents != null">
                  <template v-if="$i18n.locale == 'tr'">
                    Toplam
                    <b>{{ getEvents.length }}</b>
                    etkinliği görüntülemektesiniz.
                  </template>

                  <template v-else>
                    Showing total of
                    <b>{{ getEvents.length }}</b>
                    event(s).
                  </template>
                </span>
              </template>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('contentManagement.areaMap.searchFilter')" placement="top">
                  <el-button icon="fas fa-search" size="mini" @click="isFilterEnabled = !isFilterEnabled" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="getData" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="getEvents.length > 0">
            <div class="custom-grid-table-header ownevents-grid-template">
              <div>{{ $t("myOwnEvents.event") }}</div>
              <div>{{ $t("myOwnEvents.dateVanue") }}</div>
              <div></div>
            </div>
            <div class="list-group-o ownevents-container">
              <div class="item" v-for="item in getEvents" :key="item.id" :class="{ passive: false }">
                <div class="img-title">
                  <div class="img" :style="'background-image:url(' + $imageus + item.logo + '?width=150&height=150&mode=cover)'"></div>
                  <div class="ownevents-item-title">{{ item.title }}</div>
                </div>
                <div class="table-date">
                  <div class="date">
                    <i class="fas fa-calendar"></i>
                    <span>
                      {{
                        $moment(item.startDate)
                          .utc()
                          .format("DD MMM, YYYY - HH:mm")
                      }}
                    </span>
                    <i class="fas fa-arrow-right"></i>
                    <span>
                      {{
                        $moment(item.endDate)
                          .utc()
                          .format("DD MMM, YYYY - HH:mm")
                      }}
                    </span>
                    <b></b>
                  </div>

                  <div class="venue" v-if="item.location.venue != null || item.location.city != null || item.location.country != null">
                    <i class="fas fa-map-marker-alt"></i>
                    <span>{{ (item.location.venue != null ? item.location.venue + " " : "") + (item.location.city != null ? item.location.city + ", " : "") + (item.location.country != null ? item.location.country : "") }}</span>
                  </div>
                </div>
                <div class="action-btns">
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button type="primary" icon="fas fa-pen" circle size="mini" @click="switchEvent(item.id)"></el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-events-v2-lottie'" :title="$t('myOwnEvents.title')" @btnAdd="false" @btnRefresh="getData" :buttonAdd="false" :buttonRefresh="true" :loading="loading" />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import slugify from "slugify";
import PageCountInfo from "../components/PageCountInfo";
import $ from "jquery";

export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.events")
    };
  },

  components: { PageCountInfo },
  name: "MyOwnEvents",

  data() {
    return {
      skip: 2,
      take: 10,
      createDialog: false,
      loading: false,
      title: null,
      search: false,
      showEventSelector: false,
      searchTerm: null,
      timeout: null,
      isFilterEnabled: false
    };
  },

  methods: {
    async getData() {
      this.loading = "loadingList";
      await this.$store.dispatch("getAuthorizedEvents");
      this.loading = false;
    },
    async switchEvent(id) {
      if ((this.timeout = null)) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("login/switchevent", { id });
        if (!res.data.alert.hasError) {
          this.eventWrapperLoading(true);
          axios.defaults.headers["Authorization"] = "Bearer " + res.data.data.token;
          this.$store.state.user.token = res.data.data.token;
          localStorage.setItem("token", res.data.data.token);
          this.$router.push({ name: "event", params: { event_id: id } }).catch(() => {});
          await this.$store.dispatch("getEvent");
          await this.$store.dispatch("getSubEvents");
          await this.$store.dispatch("getGroups");
          await this.$store.dispatch("getTags");
        } else {
          this.$message.error(res.data.alert.message);
        }
        this.eventWrapperLoading(false);
      }, 500);
    },

    async createEvent() {
      this.loading = true;

      var res = await axios.post("event/create", { title: this.title });
      if (res.data.alert.hasError) {
        this.loading = false;

        this.$message.error(res.data.alert.message);
      } else {
        this.$message.success(res.data.alert.message);
        setTimeout(() => {
          this.loading = false;
          this.switchEvent(res.data.data);
        }, 2000);
      }
    }
  },
  async created() {
    await this.$store.dispatch("getOrganizationList");
    await this.$store.dispatch("getEventCategories");
    await this.$store.dispatch("getAuthorizedEvents");
  },
  // mounted() {
  //   this.$store.dispatch("events");
  // },

  computed: {
    getSearchTerm() {
      return slugify(this.searchTerm == null ? "" : this.searchTerm, {
        replacement: " ",
        lower: true
      });
    },

    getEvents() {
      var regex = new RegExp(this.getSearchTerm, "g");
      if (this.getSearchTerm == null || this.getSearchTerm == "") return this.$store.state.event.events;
      return this.$store.state.event.events.filter(
        k =>
          slugify(k.title, " ")
            .toLowerCase()
            .match(regex) ||
          slugify(k.title, " ").match(regex) ||
          k.searchTerms.some(x =>
            slugify(x, " ")
              .toLowerCase()
              .match(regex)
          )
      );
    }
  }
};
</script>

<style lang="less">
#my-own-events {
  width: 100%;

  .ownevents-grid-template {
    grid-template-columns: 1.2fr 1fr 90px;
  }

  .ownevents-container {
    display: flex;
    flex-direction: column;
    .item {
      gap: 0.5rem;
      margin-bottom: 0.5rem;
      grid-template-columns: 1.2fr 1fr 90px;

      &:last-child {
        margin-bottom: unset;
      }

      & > .action-btns {
        display: flex;
        flex-direction: row;
        gap: 0.3rem;
        .el-button {
          margin: 0;
        }
      }

      .table-date {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .date,
        .venue {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          span {
            color: #505763;
            font-size: 14px;
            font-weight: 500;
          }
          i {
            color: #06658c;
            margin-right: 4px;
            margin-left: 4px;
            font-size: 13px;
          }
          b {
            color: #06658c;
            margin-left: 4px;
          }
        }
      }

      .img-title {
        display: flex;
        gap: 1rem;
        font-weight: 500;
        align-items: center;

        & > .img {
          border-radius: 8px;
          width: 45px;
          height: 45px;
          background-size: cover !important;
          background-position: center center;
          background-repeat: no-repeat;
          overflow: hidden;
          border: 3px solid white;
          background: white;
        }

        .ownevents-item-title {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
        }
      }

      transition: all 0.5s;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      background-color: #f1f1f1;

      &.passive {
        background-color: #fff2f2 !important;
      }
      display: grid;
      padding: 10px;
      align-items: center;
      border-radius: 8px;
      transition: all 0.5s;

      & > .price-title {
        font-weight: bold;
        flex-direction: row;
        gap: 0.5rem;

        .el-input {
          width: 100%;
        }
      }

      .el-input-number {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }

      i.burger {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;
        cursor: grab;
        &.me {
          color: #ccc;
        }
      }
      & > .title {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        & > i.el-icon-loading {
          font-size: 20px;
        }
      }

      & > div:last-child {
        justify-self: flex-end;
      }
      .table-icon {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MyOwnEvents.vue